/**
 * Challenge entry repository – create entry, list by challenge (for leaderboard).
 * Ranking: max(weight) per user; tie-breaker earlier submission.
 */
import {
  collection,
  doc,
  getDocs,
  addDoc,
  query,
  where,
  orderBy,
  limit,
  onSnapshot,
} from 'firebase/firestore';
import { db } from '../firebase/config';
import { createChallengeEntry } from '../../domain/entities/ChallengeEntry';

const COLLECTION = 'challengeEntries';

export function challengeEntryRepository({ getFirestore = () => db } = {}) {
  const firestore = getFirestore();
  const coll = () => collection(firestore, COLLECTION);

  return {
    async create(data) {
      const ref = await addDoc(coll(), {
        ...data,
        createdAt: new Date(),
      });
      return ref.id;
    },

    async listByChallenge(challengeId, limitCount = 100) {
      const q = query(
        coll(),
        where('challengeId', '==', challengeId),
        orderBy('score', 'desc'),
        orderBy('createdAt', 'asc'),
        limit(limitCount)
      );
      const snap = await getDocs(q);
      const items = [];
      snap.forEach((d) => items.push(createChallengeEntry({ id: d.id, ...d.data() })));
      return items;
    },

    subscribeByChallenge(challengeId, limitCount, onUpdate) {
      const q = query(
        coll(),
        where('challengeId', '==', challengeId),
        orderBy('score', 'desc'),
        orderBy('createdAt', 'asc'),
        limit(limitCount)
      );
      return onSnapshot(q, (snap) => {
        const items = [];
        snap.forEach((d) => items.push(createChallengeEntry({ id: d.id, ...d.data() })));
        onUpdate(items);
      });
    },

    async getByChallengeAndUser(challengeId, userId) {
      const q = query(
        coll(),
        where('challengeId', '==', challengeId),
        where('userId', '==', userId),
        limit(1)
      );
      const snap = await getDocs(q);
      if (snap.empty) return null;
      const d = snap.docs[0];
      return createChallengeEntry({ id: d.id, ...d.data() });
    },
  };
}

export const challengeEntryRepo = challengeEntryRepository();
